/**
 * Proceso con Hacienda minimizado. Los modales que esperan respuesta de Hacienda no se pueden cerrar
 * (el proceso sigue corriendo), pero sí minimizar: quedan como una píldora en la barra de la pantalla
 * (el hueco `#procesos-en-curso`) que muestra que sigue trabajando; un clic vuelve a abrir el modal.
 * Si la pantalla no tiene el hueco, la píldora flota abajo a la derecha.
 */
import { createPortal } from 'react-dom';
import clsx from 'clsx';
import { CheckCircle, Loader2, XCircle } from 'lucide-react';

export const HUECO_PROCESOS = 'procesos-en-curso';

export function BotonMinimizar({ onClick }) {
  return (
    <button onClick={onClick} title="Minimizar: el proceso sigue corriendo"
      className="px-3 py-1.5 text-xs font-semibold border border-gray-300 text-gray-600 rounded-lg hover:bg-gray-50 whitespace-nowrap">
      Minimizar
    </button>
  );
}

export default function ProcesoMinimizado({ texto, avance, estado = 'corriendo', onAbrir }) {
  const hueco = document.getElementById(HUECO_PROCESOS);
  const boton = (
    <button onClick={onAbrir} title="Ver el proceso"
      className={clsx('inline-flex items-center gap-2 px-3 py-1.5 text-sm font-semibold border-[1.5px] rounded-full whitespace-nowrap bg-white',
        estado === 'corriendo' && 'border-blue-500 text-blue-700 animate-pulse',
        estado === 'listo' && 'border-green-500 text-green-700',
        estado === 'error' && 'border-red-500 text-red-700',
        !hueco && 'fixed bottom-5 right-5 z-50 shadow-lg')}>
      {estado === 'corriendo' ? <Loader2 className="w-4 h-4 animate-spin" /> : estado === 'listo' ? <CheckCircle className="w-4 h-4" /> : <XCircle className="w-4 h-4" />}
      {texto}
      {avance != null && <span className="text-xs font-normal opacity-80 tabular-nums">{avance}</span>}
    </button>
  );
  return createPortal(boton, hueco || document.body);
}
